var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Male",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.615,
    height: 69.764,
    viewBox: "0 0 32.615 69.764",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 32.615,
    height: 69.764,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M16.444,63.714c3.21,0,6.419-.03,9.629.007,5.136.06,7.894,4.263,5.882,9.025-2.82,6.675-5.756,13.3-8.529,20a13.421,13.421,0,0,0-.9,4.438c-.137,2.947-.051,5.9-.036,8.857.008,1.507-.372,2.821-2.142,2.79-1.638-.029-2.023-1.258-2.012-2.71.028-3.531-.048-7.063.04-10.591a8.859,8.859,0,0,1,.72-3.133c2.91-6.915,5.891-13.8,8.836-20.7,1.2-2.8.416-3.946-2.651-3.946-6.034,0-12.068-.01-18.1.005-2.975.007-3.726,1.14-2.569,3.855,2.919,6.842,5.892,13.661,8.745,20.53a11.872,11.872,0,0,1,.824,4.071c.116,3.334.023,6.675.043,10.012.009,1.468-.43,2.643-2.093,2.611-1.533-.029-2.012-1.143-1.971-2.538.01-.321-.041-.646,0-.962.876-7.255-.941-13.907-4.214-20.341C3.994,81.168,2.475,77.129.8,73.171c-2.291-5.423.468-9.483,6.4-9.469,3.081.007,6.163,0,9.244,0v.011",
    transform: "translate(0 -39.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M36.088,10.208A10.251,10.251,0,1,1,25.821,0,10.134,10.134,0,0,1,36.088,10.208M25.931,16.365a6.156,6.156,0,0,0,6.094-6.158,6.22,6.22,0,0,0-6.151-6.13,6.119,6.119,0,0,0-6.145,6.28,6.064,6.064,0,0,0,6.2,6.008",
    transform: "translate(-9.558 0.001)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.561fc7f05ffe3aa722d1aa54b04bcad2.svg";
export { ForwardRef as ReactComponent };